import { Body, Box, BoxProps, Container, Icon } from '@hover/blueprint';
import { iCheckCircle, IconProp } from '@hover/icons';
import React from 'react';

interface Props extends BoxProps {
  icon: IconProp;
  header: string;
  body: string;
}

const InfoBox: React.FC<Props> = ({ icon, header, body, ...restProps }) => (
  <Box
    flexDir="column"
    alignItems="center"
    maxW={{ base: 'auto', tablet: '277px' }}
    {...restProps}
  >
    <Box
      h={500}
      w={500}
      borderRadius="50%"
      alignItems="center"
      justifyContent="center"
      mb={500}
      bg="primary.100"
    >
      <Icon icon={iCheckCircle} m={0} size="large" color="brandNavy.500" />
    </Box>
    <Container px={0}>
      <Body
        as="h3"
        textAlign="center"
        isBold
        marginBottom={300}
        fontSize="24px"
      >
        {header}
      </Body>
      <Box justifyContent="center">
        <Body textAlign="center" fontSize="18px">
          {body}
        </Body>
      </Box>
    </Container>
  </Box>
);

export default InfoBox;
